<script>
import BasePagination from "../../common/global/BasePagination.vue";
export default {
  name: "ChargemapPagination",
  components: { BasePagination },
  props: {
    modelValue: {
      type: Number,
      required: true
    },
    perPage: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      default: 0
    }
  },
  emits: ["update:model-value"],
  methods: {
    goTo(index) {
      this.$emit("update:model-value", index);
    }
  }
};
</script>

<template>
    <div class="b2c-pagination-wrapper">
        <BasePagination v-bind="$props" @update:model-value="goTo" />
    </div>
</template>

<style>
.b2c-pagination-wrapper .pagination {
  @apply flex gap-2;
}
.b2c-pagination-wrapper .pagination button {
  @apply flex items-center justify-center rounded-full size-10 bg-zinc-100;
}
.b2c-pagination-wrapper .pagination button:disabled:not(.pagination--page__active) {
  @apply cursor-not-allowed text-gray-disabled;
}
.b2c-pagination-wrapper .pagination--page:hover:not(:disabled) {
  @apply border border-badge-info text-primary-info bg-white;
}
.b2c-pagination-wrapper .pagination--page__active {
  @apply border border-light-blue-primary bg-primary-light text-primary-info;
}
.b2c-pagination-wrapper .pagination--page:disabled {
  @apply cursor-not-allowed;
}
.b2c-pagination-wrapper .pagination--page:disabled {
  @apply cursor-not-allowed;
}
.b2c-pagination-wrapper .pagination--page__hidden {
  @apply cursor-default;
}
.b2c-pagination-wrapper .pagination--prev svg, .b2c-pagination-wrapper .pagination--next svg {
  @apply size-6;
}
.b2c-pagination-wrapper .pagination--prev svg, .b2c-pagination-wrapper .pagination--next svg {
  @apply size-6;
}
</style>
